import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';

// MANAGERS & TYPES
import { useAppSelector } from '@Managers/Redux/Hooks';

import { getGameStore } from '@Managers/Redux/AppState/AppState';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { TJackpotCasinoLevelItem, TJackpotCasinoUsersHit, TJackpotCasinoUsersHitLevelItem } from '@GFTypes/index';
import styles from './JackpotCasino.scss';

//SUBMOBULES
import JackpotCasinoStatusGroup from './JackpotCasinoStatusGroup';
import JackpotCasinoHitGroup from './JackpotCasinoHitGroup';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

interface IComponentState {
    show: boolean;
    available: boolean;
    statusLevels: Array<Array<TJackpotCasinoLevelItem>>;
    hitsLevels: Array<TJackpotCasinoUsersHitLevelItem>;
    userHit?: TJackpotCasinoUsersHit;
}

const JackpotCasino: React.FC = () => {
    const [state, setState] = useReducer((s: IComponentState, ns: Partial<IComponentState>) => ({ ...s, ...ns }), {
        statusLevels: [],
        show: false,
        hitsLevels: [],
        userHit: undefined,
        available: false
    });
    const gameStore = useAppSelector(getGameStore);

    useEffect(() => {
        setState({ available: ConfigLoader.getConfiguration(EConfigurationNames.GAME).dynamicCasinoJackpot.available });
    }, []);

    useEffect(() => {
        let data = [...state.statusLevels];
        let newStatus = [...gameStore[EGameStoreKeys.JackpotCasinoState].statusLevels];
        newStatus.sort(compare).reverse();
        data.push(newStatus);

        if (data.length > 2) {
            data.shift();
        }
        setState({ statusLevels: data, show: true });
    }, [gameStore[EGameStoreKeys.JackpotCasinoState].statusLevels]);

    useEffect(() => {
        setState({ hitsLevels: gameStore[EGameStoreKeys.JackpotCasinoState].hitsLevels });
    }, [gameStore[EGameStoreKeys.JackpotCasinoState].hitsLevels]);

    useEffect(() => {
        setState({ userHit: gameStore[EGameStoreKeys.JackpotCasinoState].userHit });
    }, [gameStore[EGameStoreKeys.JackpotCasinoState].userHit]);

    function compare(a: TJackpotCasinoLevelItem, b: TJackpotCasinoLevelItem) {
        if (a.levelOrder < b.levelOrder) {
            return -1;
        }
        if (a.levelOrder > b.levelOrder) {
            return 1;
        }
        return 0;
    }

    return (
        <>
            {state.available ? (
                <>
                    {state.show && (
                        <div className={cn(styles.jackpot_casino_container, !gameStore[EGameStoreKeys.JackpotCasinoState].enabled ? styles.disbled : {})}>
                            <div className={styles.jackpot_casino_header}>
                                Jackpot Casino State:
                                {gameStore[EGameStoreKeys.JackpotCasinoState].enabled ? (
                                    <span className={styles.jackpot_casino_state_enabled}>enabled</span>
                                ) : (
                                    <span className={styles.jackpot_casino_state_disabled}>disabled</span>
                                )}
                            </div>
                            <div className={styles.jackpot_casino_states_container}>
                                <JackpotCasinoStatusGroup levelsData={state.statusLevels} index={0} groupLabel={'Previous state'} />
                                <JackpotCasinoStatusGroup
                                    levelsData={state.statusLevels}
                                    index={1}
                                    groupLabel={'Current state'}
                                    options={{ growthTrend: true }}
                                />
                                <JackpotCasinoHitGroup hitsData={state.hitsLevels} />
                            </div>
                            {state.userHit && (
                                <div className={styles.jackpot_casino_user_hit}>
                                    <div className={styles.jackpot_casino_user_hit_header}>Jackpot User hit:</div>

                                    <div className={styles.jackpot_casino_user_hit_container}>
                                        {state.userHit.levels.map((e, i) => {
                                            return (
                                                <div className={styles.jackpot_casino_user_hit_level_item}>
                                                    <div className={styles.jackpot_casino_user_hit_label}>{e.levelName}</div>
                                                    <div className={styles.jackpot_casino_user_hit_value}>
                                                        {CurrencyUtils.formatRawCurrencyValue(e.hitValue)}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </>
            ) : (
                <>JAKCPOT CASINO IS DISABLED BY CONFIGURATION</>
            )}
        </>
    );
};

export default JackpotCasino;
